// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1f2fz","dragIcon":"SortableItem_dragIcon__NoUZp","disabled":"SortableItem_disabled__1_ABb"};